import { render, staticRenderFns } from "./AssetReturn.vue?vue&type=template&id=fd9d452a&"
import script from "./AssetReturn.vue?vue&type=script&lang=js&"
export * from "./AssetReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports